import WorkClient from '../api/workClient';

const getAllSelectedUsers = () => {
  return WorkClient.getAllSelectedUsers();
};

const updateSelectedUsers = (emails: string[]) => {
  return WorkClient.updateSelectedUsers(emails);
};

const SelectedUsersService = {
  getAllSelectedUsers,
  updateSelectedUsers
};

export default SelectedUsersService;
